import { Component, Input, SimpleChanges } from '@angular/core';
import { ClaimDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/claim-dto';
import { DateOnly } from 'src/app/auto-generated-server-dtos/date-only';

@Component({
  selector: 'app-discrepancies',
  templateUrl: './discrepancies.component.html',
  styleUrl: './discrepancies.component.scss'
})
export class DiscrepanciesComponent {
  @Input() claimDto!: ClaimDto;
  @Input() customerRecordMatch = false;

  discrepancies = {
      odometer: false,
      manuallyEnteredDeductible: false,
      createdOverMonthOld: false,
      customerRecordMatch: true,
      discrepancyFound: false
  }

  ngOnInit() {
    this.determineDiscrepancies();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.claimDto) {
      this.determineDiscrepancies()
    }
  }
  determineDiscrepancies() {
    if ((this.claimDto.odometerReading ?? 0) < this.claimDto.lastKnownMaintenanceOdometer.reading) {
        this.discrepancies.odometer = true;
        this.discrepancies.discrepancyFound = true;
    }

    if (this.claimDto.manuallyEnteredDeductible !== null) {
        this.discrepancies.manuallyEnteredDeductible = true;
        this.discrepancies.discrepancyFound = true;
    }

    if (this.overMonthOld(this.claimDto.dateOfOccurrence!)) {
        this.discrepancies.createdOverMonthOld = true;
        this.discrepancies.discrepancyFound = true;
    }

    if (!this.customerRecordMatch) {
        this.discrepancies.customerRecordMatch = false;
        this.discrepancies.discrepancyFound = true;
    }

    return this.discrepancies;
  }

   private overMonthOld(dateString: DateOnly): boolean {
      const inputDate = new Date(dateString)
      const currentDate = new Date()

      const timeDifference = currentDate.getTime() - inputDate.getTime();

      const dayDifference = timeDifference / (1000 * 3600 * 24);

      return dayDifference > 30;
  }
}
